import { writable, derived } from 'svelte/store';

export type Lang = 'en' | 'es' | 'fr' | 'de' | 'it';

export const locale = writable<Lang>('en');

export function isValidLang(lang: string): lang is Lang {
  return ['en', 'es', 'fr', 'de', 'it'].includes(lang as Lang);
}

type Translations = Record<string, string>;

const translations = writable<Translations>({});

export const translate = derived(
  [locale, translations],
  ([$locale, $translations]) => (key: string) => $translations[key] || key
);

export async function loadTranslations(lang: Lang, fetch: any) {
  const res = await fetch(`/translations/${lang}.json`);
  const newTranslations = await res.json();
  translations.set(newTranslations);
}

export function changeLocale(newLocale: Lang) {
  if (isValidLang(newLocale)) {
    locale.set(newLocale);
  } else {
    console.error(`Invalid language: ${newLocale}`);
  }
}
